<template>
    <div>
        <el-table :data="compare" border style="width:97%">
            <el-table-column label="修订项" prop="name"></el-table-column>
            <el-table-column label="修订后" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
            <el-table-column label="修改前" prop="before">
                <template slot-scope="scope">
                    <span v-html="scope.row.before"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import Params from "~/config/params";
    export default {
        name: "jb3",
        props: {
            edit_content: {
                required: true
            }
        },
        created() {
            this.getCompare();
        },
        data() {
            return {
                compare: [],
                expire_types: [
                    '永久',
                    '7天',
                    '30天',
                    '1分钟测试使用',
                    '1天'
                ]
            }
        },
        methods: {
            getCompare() {
                this.setExpireType();
                this.setDay();
                this.setPersonDown();
                this.setBatch();
            },
            setExpireType() {
                let day_down = {
                    name: '修改有效期',
                    before: '',
                    after: ''
                };
                if(this.edit_content.content.expire_type != ''){
                    let expire_at = '';
                    if(this.edit_content.content.expire_type == 1){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400 * 7);
                    }else if(this.edit_content.content.expire_type == 2){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400 * 30);
                    }else if(this.edit_content.content.expire_type == 3){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 60);
                    }else if(this.edit_content.content.expire_type == 4){
                        expire_at = Params.timestampToDateTime(this.edit_content.created_at + 86400);
                    }
                    day_down.after = "<span style='color: red'>" + this.expire_types[this.edit_content.content.expire_type] + "</span> 到期时间：" + expire_at;
                }
                this.compare.push(day_down);
            },
            setDay() {
                let day = {
                    name: '日额度设置',
                    before: '',
                    after: ''
                };
                let before = this.edit_content.before_content.limit_configure.day.all;
                let after =  this.edit_content.content.limit_configure.day.all;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                day.before = before;
                day.after = after;
                this.compare.push(day);
            },
            setPersonDown() {
                let All = {
                    name: '个人日额度',
                    before: '',
                    after: ''
                };
                let before = this.edit_content.before_content.limit_configure.user_common_quota;

                let after =  this.edit_content.content.limit_configure.user_common_quota;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                All.before = before;
                All.after = after;
                this.compare.push(All);
            },
            setBatch() {
                this.edit_content.before_content.limit_configure.batch.map(i => {
                    if (i.subject_id === 0) return;
                    let subject = {
                        name: '',
                        before: '',
                        after: ''
                    }
                    subject.name = i.subject_name;
                    let before = '';
                    let after = '';

                    before += '小学 普:' + i.config.primary.pu + " 精:" + i.config.primary.jing + " 特:" + i.config.primary.te + '<br/>';
                    before += '初中 普:' + i.config.middle.pu + " 精:" + i.config.middle.jing + " 特:" + i.config.middle.te + "<br/>";
                    before += '高中 普:' + i.config.high.pu + " 精:" + i.config.high.jing + " 特:" + i.config.high.te + '<br/>';

                    let content = this.edit_content.content.limit_configure.batch.find(j=>{
                        return j.subject_id == i.subject_id;
                    });
                    after += '小学 普:' + content.config.primary.pu + " 精:" + content.config.primary.jing + " 特:" + content.config.primary.te + '<br/>';
                    after += '初中 普:' + content.config.middle.pu + " 精:" + content.config.middle.jing + " 特:" + content.config.middle.te + '<br/>';
                    after += '高中 普:' + content.config.high.pu + " 精:" + content.config.high.jing + " 特:" + content.config.high.te + '<br/>';
                    if(before !== after){
                        after = "<span style='color: red'>"+after+"</span>";
                    }
                    subject.before = before;
                    subject.after = after;
                    this.compare.push(subject);

                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/jb3.vue